import type { Client } from "../client";
import type { TagSetResource } from "../resources/tagSetResource";
import BasicRepository from "./basicRepository";

class TagSetRepository extends BasicRepository<TagSetResource, TagSetResource> {
    constructor(client: Client) {
        super("TagSets", client);
    }
    sort(ids: string[]) {
        return this.client.put(this.client.getLink("TagSetSortOrder"), ids);
    }
}

export default TagSetRepository;
